import './instagram_message_builder.js.coffee'
import '../instagram_message_unsupported.js.coffee'
Namespace 'Models.Builders'

class Models.Builders.InstagramMessageUnsupportedBuilder extends Models.Builders.InstagramMessageBuilder
  constructor: ->
    super()
    @isKeepconUnsupported = null

  build: ->
    new Models.InstagramMessageUnsupported(@)
